import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import * as Colors from './Colors';

interface LocalState {
    open: boolean
    title: string
    message: string
    textAlign: 'left' | 'center'
}

var instance: AlertDialog | null = null;

class AlertDialog extends React.Component<{}, LocalState> {
    constructor(props: {}) {
        super(props);
        this.state = { open: false, title: 'エラー', message: '', textAlign: 'center' };
    }

    public componentDidMount() {
        instance = this;
    }

    public componentWillUnmount() {
        if (instance === this) instance = null;
    }

    public static show(message: string, title?: string, textAlign?: 'left' | 'center') {
        if (instance) {
            instance.setState({
                open: true,
                message: message,
                title: title || 'エラー',
                textAlign: textAlign || 'center'
            });
        }
    }

    private handleClose = () => {
        this.setState({ open: false });
    }

    public render() {
        if (!this.state.open) return null;
        return (
            <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth style={{ zIndex: 9999 }}>
                <DialogTitle style={{ backgroundColor: Colors.primaryColor, color: Colors.backColor, padding: '12px 24px' }}>
                    {this.state.title}
                </DialogTitle>
                <DialogContent style={{ marginTop: 16 }}>
                    <DialogContentText style={{ whiteSpace: 'pre-line', color: '#333', textAlign: this.state.textAlign }}>{this.state.message}</DialogContentText>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                    <Button onClick={this.handleClose} variant="contained"
                        style={{ backgroundColor: Colors.primaryColor, color: '#fff', minWidth: 100 }}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default AlertDialog;
